import React, { useState, useCallback } from 'react';
import { useSessionContext } from '../../context/sessionContext';
import SetupErrorModal from '../../components/Modals/SetupErrorModal';
import { Icon } from 'antd';
import { GetStarted } from './styles';
import { withTranslation } from 'react-i18next';
import { LANDING_PAGE } from './translationValues';
import { ENTERPRISE_ENV } from '../../utils/helper';

const NAMESPACES = ['LANDING_PAGE'];

const StartDesignButton = ({ t, handleClick, checkingLimit }) => {
  const organisationSelector = useCallback(store => ({ ...store }), []);
  const [organizationDetails] = useSessionContext(organisationSelector);

  const isSaasSetupFailed =
    !ENTERPRISE_ENV &&
    organizationDetails?.userData?.userType === 'client' &&
    organizationDetails?.organizationSetup !== 'completed';

  const [showError, setShowError] = useState(false);
  return (
    <>
      <div className="app_button">
        <GetStarted
          onClick={() => {
            if (isSaasSetupFailed) setShowError(true);
            else handleClick();
          }}
        >
          {checkingLimit ? (
            <button disabled>
              <Icon type="loading" />{' '}
              {t(
                LANDING_PAGE.BUTTON_TEXT_PLEASE_WAIT.key,
                LANDING_PAGE.BUTTON_TEXT_PLEASE_WAIT.value,
              )}
            </button>
          ) : (
            <button
              data-hover={t(
                LANDING_PAGE.START_DESIGN_BUTTON.key,
                LANDING_PAGE.START_DESIGN_BUTTON.value,
              )}
            >
              <div>
                {t(LANDING_PAGE.START_DESIGN_BUTTON.key, LANDING_PAGE.START_DESIGN_BUTTON.value)}
              </div>
            </button>
          )}
        </GetStarted>
      </div>
      <SetupErrorModal showError={showError} setShowError={setShowError} />
    </>
  );
};

export default withTranslation(NAMESPACES)(StartDesignButton);
